(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonedaDetailController', MonedaDetailController);

    MonedaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Moneda', 'Comercio'];

    function MonedaDetailController($scope, $rootScope, $stateParams, previousState, entity, Moneda, Comercio) {
        var vm = this;

        vm.moneda = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:monedaUpdate', function(event, result) {
            vm.moneda = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
